/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TicketParam { 
    /**
     * Id Hash. UTI (Unique Ticket Identifier). Maximum lenght 88. Mandatory in the PUT Service. Must not be specified in the POST Service. Optional in the GET Service.
     */
    idHash?: string;
    /**
     * Id Hash. UTTI (Unique Ticket Type Identifier). Maximum lenght 88. Mandatory in the POST and PUT Services. Optional in the GET Service.
     */
    idHashTicketType?: string;
    /**
     * Id Hash. UUI (Unique User Identifier). Maximum lenght 88. Mandatory in the POST and PUT Servics. Optional in the GET Service.
     */
    idHashUser?: string;
    /**
     * Status.
     */
    status: string;
    /**
     * Guest.
     */
    guest?: boolean;
    /**
     * Fiat price for resaling the ticket.
     */
    fiatResalePrice?: number;
    /**
     * Crypto price for resaling the ticket.
     */
    cryptoResalePrice?: number;
    /**
     * Section. Maximum lenght 20
     */
    section?: string;
    /**
     * Section. Maximum lenght 20
     */
    row?: string;
    /**
     * Section. Maximum lenght 20
     */
    seat?: string;
    /**
     * Featured image
     */
    featuredImage?: string;
}

